// Lib
import { ThemeFile } from 'lib/context/ThemeContext';

export const ReviewSummaryTheme: ThemeFile = {
  aw: {
    classes: {},
  },
  rba: {
    classes: {
      summaryTitle: 'font-serif font-bold border-t border-t-gray pt-s sm:ml-[4px] text-s mb-xxs',
      ratingsWrapper: 'lg:w-auto lg:items-center hidden md:block md:w-full md:items-start lg:px-l',
      ratingsAndReviewCountWrapper:
        'flex flex-row md:py-xs items-center lg:w-auto lg:justify-center gap-[4px] mb-xxs md:gap-2 lg:mb-m lg:w-1/4 lg:pr-m',
      ratingText: 'md:ml-1 font-medium font-sans text-m md:text-xl',
      ratingsIconsList:
        'flex hover:bg-light-gray w-fit gap-2 md:gap-3 md:pr-4 rating-button lg:w-full',
      progressBarWrapper:
        'px-xxs mt-xxs md:mt-0 md:flex-1 md:min-w-[200px] md:max-w-[420px] reviewBar lg:mt-0 lg:w-full lg:min-w-0 lg:max-w-none relative overflow-hidden',
      totalReviewsText:
        'flex text-xxs font-regular font-serif items-end pr-s text-dark-gray justify-center gap-[4px] md:pr-0 md:items-center whitespace-nowrap lg:pl-2 lg:shrink-0 lg:relative max-[360px]:text-[10px] max-[360px]:gap-[2px]',
    },
  },
};
